export const buildingSearchQueryBase = {
	withTrashed: true,
	_limit: 15,
	_sort: 'city,address',
};
